import React from "react";

import { useFormikContext } from "formik";
import { SourceEnum } from "../../../../enums/template";
import { Template } from "../../../../models";

import SwitchContainer from "../common/SwitchContainer";

export default function EmbedVideoToggle() {
  const { values, setFieldValue } = useFormikContext<Partial<Template>>();
  if (
    ![
      SourceEnum.INSTAGRAM_REELS,
      SourceEnum.YOUTUBE_SHORTS,
      SourceEnum.YOUTUBE_VIDEOS,
      SourceEnum.APPLE_PODCASTS,
    ].includes(values?.sourceId!)
  ) {
    return null;
  }

  return (
    <SwitchContainer
      title="Embed the video into the Article"
      subTitle=""
      tooltip="This will embed the video right into the article."
      enabled={!!values?.includeWebEmbed}
      setEnabled={() =>
        setFieldValue("includeWebEmbed", !values?.includeWebEmbed)
      }
    />
  );
}
